var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12117_5459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 30.0406V168.96C111 176.964 99.9052 181.005 93.3468 175.388L45.8098 134.672C43.8689 133.01 41.2547 132.078 38.5305 132.078H10.3738C4.64436 132.078 0 128.039 0 123.056V76.629C0 71.6459 4.64436 67.6065 10.3738 67.6065H38.4828C41.235 67.6065 43.8741 66.6556 45.8202 64.9621L93.2898 23.6617C99.8243 17.9766 111 22.0015 111 30.0406Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 59,
    width: 15,
    height: 100,
    rx: 7.5,
    transform: "rotate(45 192 59)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 59,
    width: 15,
    height: 100,
    rx: 7.5,
    transform: "rotate(45 192 59)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 130,
    width: 15,
    height: 100,
    rx: 7.5,
    transform: "rotate(135 202 130)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 130,
    width: 15,
    height: 100,
    rx: 7.5,
    transform: "rotate(135 202 130)",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12117_5459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMuted);
export default __webpack_public_path__ + "static/media/soundMuted.f5d970d3ce6bea50f7edc6d743cfa26a.svg";
export { ForwardRef as ReactComponent };